module.exports = __webpack_public_path__ + "img/icon-btn-minus.0670a757.svg";